/* @flow */

import React, { Component } from 'react';
import { Divider, Form } from 'semantic-ui-react';
import ResourceCard from 'shared/components/ResourceCard';
import * as ResourceServices from 'catalog/services/resources';

type Props = {
  block: EditorialBlock,
  onSerialize?: (block: EditorialBlock) => void,
};

const DEFAULT_ASPECT = 16 / 9;

class Edit extends Component {
  props: Props;

  serializeBlock(block) {
    this.props.onSerialize(block);
  }

  renderContent() {
    const { block } = this.props;

    const strategy = ResourceServices.createServerDrivenStrategy({
      aspect: DEFAULT_ASPECT,
    });

    const resourceSelected = resource =>
      this.serializeBlock({
        ...block,
        pdf: {
          resourceId: resource.id,
          resource: resource,
          strategy: {
            ...strategy,
            source: resource.id,
          },
        },
      });

    const resourceDeleted = () =>
      this.serializeBlock({
        ...block,
        pdf: undefined,
      });

    return (
      <ResourceCard
        resourceType="pdf"
        resource={block.pdf && block.pdf.resource}
        onSelected={resourceSelected}
        onDeleted={resourceDeleted}
      />
    );
  }

  render() {
    const { block } = this.props;

    const captionChanged = event =>
      this.serializeBlock({
        ...block,
        caption: event.target.value,
      });

    return (
      <div>
        <Form>
          <Form.Field>
            <label>Légende</label>
            <input
              placeholder="Légende"
              value={block.caption || ''}
              onChange={captionChanged}
            />
          </Form.Field>
        </Form>
        <Divider />
        {this.renderContent()}
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/pdf/Edit.js